import review from "../../../../../assets/images/review.svg";
import alert from "../../../../../assets/images/alert.svg";
import success from "../../../../../assets/images/success.svg";
import styles from "./ActionCard.module.scss";
import { useState } from "react";
import { constants } from "../../../../../common/constants/constants";
import ConfirmContactNo from "../../../../supplier/confirmContactNo/ConfirmContactNo";
import { SideDrawer } from "../../../../../common/components/SideDrawer/SideDrawer";

export type actionCardState = "Default" | "Review" | "Success" | "Error";

export interface CardStateContent {
  heading: string;
  content: string;
  action?: string; // Optional because some states (like Review) might not have actions
}

export interface actionCard {
  Default: CardStateContent;
  Review?: CardStateContent;
  Success?: CardStateContent;
  Error?: CardStateContent;
}

// Main component props interface
export interface IActionCard {
  // Required props
  state: actionCardState;
  icon: string; // SVG/image path
  iconOnHover: string; // SVG/image path for hover state
  actionCardData: actionCard;

  // Optional props
  onClick?: () => void; // Custom click handler (for specific cards like add_products)

  // Styling props (if needed)
  className?: string;
  disabled?: boolean;
}

export const ActionCard = (props: IActionCard) => {
  const [icon, setIcon] = useState(props.icon);
  const [isdrawer, setIsDrawer] = useState({
    right: false,
  });

  function handleMouseEnter() {
    setIcon(props.iconOnHover);
  }

  function handleMouseLeave() {
    setIcon(props.icon);
  }

  let onboardingDashboardCards = props.actionCardData;
  let card: any;
  if (props.state === constants.onboardingDashboardCard.REVIEW) {
    card = onboardingDashboardCards.Review;
  } else if (props.state === constants.onboardingDashboardCard.ERROR) {
    card = onboardingDashboardCards.Error;
  } else if (props.state === constants.onboardingDashboardCard.SUCCESS) {
    card = onboardingDashboardCards.Success;
  } else {
    card = onboardingDashboardCards.Default;
  }
  return (
    <>
      <div
        style={{
          cursor: props.disabled ? "not-allowed" : "pointer",
        }}
        className={`${styles.card} ${styles.supplierCard} ${
          props.state === constants?.onboardingDashboardCard?.ERROR
            ? styles.redBorder
            : props.state === constants?.onboardingDashboardCard?.SUCCESS
            ? styles.greenBorder
            : props.state === constants?.onboardingDashboardCard?.REVIEW
            ? styles.orangeBorder
            : ""
        }`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        data-testid="card"
        onClick={props.onClick}
      >
        <div className={styles.icon}>
          <img src={icon} alt="icon" data-testId="icon"></img>
        </div>
        <div className={`${styles.cardContent} ${styles.supplierCardContent}`}>
          <div
            className={`${styles.heading} ${
              props.state === constants.onboardingDashboardCard.REVIEW
                ? styles.reviewHeading
                : props.state === constants.onboardingDashboardCard.ERROR
                ? styles.errorHeading
                : props.state === constants.onboardingDashboardCard.SUCCESS
                ? styles.successHeading
                : ""
            }`}
            data-testId="heading"
          >
            {card?.heading}
          </div>
          <div className={`${styles.content} ${styles.supplierContent}`}>
            {card?.content}
          </div>
          {card?.action && (
            <button
              className={`${styles.link} ${styles.supplierLink}`}
              data-testId="handleClickbutton"
              onClick={props.onClick}
            >
              {card.action}
            </button>
          )}
        </div>
        {props.state === constants.onboardingDashboardCard.ERROR && (
          <div className={`${styles.stateIcon} ${styles.error}`}>
            <img
              className={styles.stateIconImage}
              src={alert}
              alt="error state icon"
            ></img>
          </div>
        )}
        {props.state === constants.onboardingDashboardCard.SUCCESS && (
          <div className={`${styles.stateIcon} ${styles.success}`}>
            <img
              className={styles.stateIconImage}
              src={success}
              alt="success state icon"
            ></img>
          </div>
        )}
        {props.state === constants.onboardingDashboardCard.REVIEW && (
          <div className={`${styles.stateIcon} ${styles.review}`}>
            <img
              className={styles.stateIconImage}
              src={review}
              alt="review state icon"
            ></img>
          </div>
        )}
      </div>
      {isdrawer.right && (
        <SideDrawer
          isdrawer={isdrawer}
          setIsDrawer={setIsDrawer}
          heading={constants.confirmContactNo.heading}
          childComponent={<ConfirmContactNo overlayCallback={setIsDrawer} />}
        />
      )}
    </>
  );
};
export default ActionCard;
